import React, { useState } from 'react';

// Drag-and-drop and click/keyboard mapping helpers shared by the source tree and the slots.

export type DragPathRef = React.MutableRefObject<string[] | null>;

// Keyboard/click-mapping handshake: a drop slot calls this on Enter or click to hand its
// "pick" callback to useKeyboardPick, which then moves focus into the source tree. Selecting a
// leaf (Enter or click) invokes the callback with that leaf's path. Mirrors the
// drag-and-drop flow for keyboards and for slots scrolled out of drag reach.
export type StartPick = (
  onPick: (path: string[]) => void,
  slotEl: HTMLElement,
) => void;

// Applied imperatively to the armed slot while a pick is in progress (the slot's own
// render doesn't know it is the pending one — the pick state lives in useKeyboardPick).
// slot-armed turns the dashed outline teal (index.css); the classes go on the
// slot's dashed wrapper, not the inner target the pick was started from.
export const ARMED_SLOT_CLASSES = ['slot-armed', 'animate-pulse'];
export const armTarget = (el: HTMLElement | null | undefined) =>
  (el?.closest('[data-empty-slot]') as HTMLElement | null) ?? el ?? null;

export function useDragOver(readOnly: boolean) {
  const [isOver, setIsOver] = useState(false);

  const handlers = readOnly
    ? {}
    : {
        onDragOver: (e: React.DragEvent) => {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'copy';
          setIsOver(true);
        },
        onDragLeave: () => setIsOver(false),
      };

  const resetOver = () => setIsOver(false);

  return { isOver, handlers, resetOver };
}
